document.addEventListener('click', function(e){
  const btn=e.target.closest('[data-menu-toggle]');
  if(btn){document.querySelector('.mm-nav')?.classList.toggle('is-open');}
  const thumb=e.target.closest('[data-product-thumb]');
  if(thumb){
    const main=document.querySelector('[data-main-product-image]');
    if(main){main.src=thumb.dataset.full; main.srcset='';}
    document.querySelectorAll('[data-product-thumb]').forEach(t=>t.classList.remove('is-active'));
    thumb.classList.add('is-active');
  }
});